/* SKINGRAPHICA redesign, The Tattoo Care Guide. Planner, section bar and calendar export */
(function () {
  'use strict';
  var root = document.querySelector('[data-cg]');
  if (!root) return;
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  var DATA = {}, PROD = {};
  try { DATA = JSON.parse($('[data-cg-data]').textContent); } catch (e) {}
  try { PROD = JSON.parse($('[data-cg-prod]').textContent); } catch (e) {}

  /* icons used by the planner output */
  var IC = {
    tick: '<path d="M5 12.6l4.3 4.3L19 7.2"/>',
    cal: '<rect x="3.6" y="5.2" width="16.8" height="15.2" rx="1.4"/><path d="M3.6 9.6h16.8M8 3.2v4M16 3.2v4"/>',
    clock: '<circle cx="12" cy="12" r="8.2"/><path d="M12 7.6V12l3 2"/>',
    shield: '<path d="M12 3.2l7 2.6v6.1c0 4.3-3 7.6-7 9-4-1.4-7-4.7-7-9V5.8z"/>',
    dl: '<path d="M12 4v11M7 10.5l5 5 5-5M4.5 19.6h15"/>',
    info: '<circle cx="12" cy="12" r="8.2"/><path d="M12 11v5.2"/><circle class="f" cx="12" cy="8" r=".9"/>',
    doc: '<path d="M6.2 3.4h8.2l3.8 3.8v13.4H6.2z"/><path d="M14.2 3.6v3.8h3.8M9 12.4h6.4M9 15.6h6.4M9 9.2h2.6"/>',
    mail: '<rect x="3.4" y="5.6" width="17.2" height="12.8" rx="1.2"/><path d="M3.8 6.4l8.2 6.4 8.2-6.4"/>',
    share: '<path d="M12 3.6v11M7.6 8l4.4-4.4L16.4 8"/><path d="M8.6 11.2H5.8v9.2h12.4v-9.2h-2.8"/>',
    link: '<path d="M10.2 13.8a3.6 3.6 0 0 0 5.1 0l3.1-3.1a3.6 3.6 0 0 0-5.1-5.1l-1.3 1.3"/><path d="M13.8 10.2a3.6 3.6 0 0 0-5.1 0l-3.1 3.1a3.6 3.6 0 0 0 5.1 5.1l1.3-1.3"/>'
  };
  function ic(n) { return '<svg class="cg-i" viewBox="0 0 24 24" aria-hidden="true">' + IC[n] + '</svg>'; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* sticky section bar sits just under the site header, whatever the header is doing */
  var bar = $('[data-cg-nav]');
  var hdr = document.querySelector('.sg-hdr-sec') || document.querySelector('header');
  function setTop() {
    var t = 0;
    if (hdr) { var r = hdr.getBoundingClientRect(); t = Math.max(0, Math.round(r.bottom)); }
    root.style.setProperty('--cg-top', t + 'px');
  }
  var ticking = false;
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { setTop(); spy(); ticking = false; }); } }, { passive: true });
  window.addEventListener('resize', setTop);
  setTop();

  /* the bar follows the reader */
  var links = $$('a[data-for]', bar);
  var secs = links.map(function (a) { return document.getElementById(a.getAttribute('data-for')); });
  var current = '';
  function spy() {
    var y = (parseFloat(getComputedStyle(root).getPropertyValue('--cg-top')) || 0) + 120, id = '';
    /* the section nearest above the line wins, whatever order the bar lists them in (Warning signs sits between Recover and Protect on the page) */
    var best = -Infinity;
    secs.forEach(function (s) { if (!s) return; var t = s.getBoundingClientRect().top; if (t <= y && t > best) { best = t; id = s.id; } });
    if (id === current) return;
    current = id;
    links.forEach(function (a) {
      var on = a.getAttribute('data-for') === id;
      a.classList.toggle('on', on);
      if (on) {
        var sc = a.parentNode, pad = parseFloat(getComputedStyle(sc).paddingLeft) || 0;
        var l = a.getBoundingClientRect().left - sc.getBoundingClientRect().left + sc.scrollLeft;
        if (l - pad < sc.scrollLeft || l + a.offsetWidth > sc.scrollLeft + sc.clientWidth) sc.scrollTo({ left: a === links[0] ? 0 : Math.max(0, l - pad), behavior: 'smooth' });
      }
    });
  }
  spy();

  /* planner */
  var form = $('[data-cg-form]'), out = $('[data-cg-out]');
  if (!form || !out) return;
  var KEY = 'sg-care-plan';
  var DAY = 864e5;
  function today() { var d = new Date(); d.setHours(0, 0, 0, 0); return d; }
  function parse(v) { if (!/^\d{4}-\d{2}-\d{2}$/.test(v || '')) return null; var p = v.split('-'); var d = new Date(+p[0], +p[1] - 1, +p[2]); return isNaN(d) ? null : d; }
  function add(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function diff(a, b) { return Math.round((a - b) / DAY); }
  var LOC = /-/.test(document.documentElement.lang || '') ? document.documentElement.lang : 'en-AU';
  function fmt(d, o) { try { return d.toLocaleDateString(LOC, o); } catch (e) { return d.toDateString(); } }
  function dd(d) { return fmt(d, { day: 'numeric' }); }
  function mm(d) { return fmt(d, { month: 'short' }); }
  function long(d) { return fmt(d, { weekday: 'long', day: 'numeric', month: 'long' }); }

  function state() {
    var s = {};
    ['mode', 'age', 'size', 'style', 'first'].forEach(function (n) { var el = form.querySelector('input[name="' + n + '"]:checked'); s[n] = el ? el.value : ''; });
    s.place = form.place.value;
    s.date = form.date.value;
    return s;
  }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  /* a plan travels as a link, so it opens the same on any phone or computer */
  var FIELDS = ['mode', 'date', 'age', 'place', 'size', 'style', 'first'];
  function fromUrl() {
    var v = null;
    try { v = new URLSearchParams(location.search).get('plan'); } catch (e) {}
    if (!v) return null;
    var a = v.split('~'), s = {};
    FIELDS.forEach(function (k, i) { s[k] = (a[i] || '').replace(/[^\w-]/g, ''); });
    return s.mode ? s : null;
  }
  function planUrl(s) {
    return location.origin + location.pathname + '?plan=' + FIELDS.map(function (k) { return s[k] || ''; }).join('~').replace(/~+$/, '') + '#plan';
  }
  var linked = false;
  function load() {
    var s = fromUrl();
    if (s) linked = true;
    /* nothing is pre-selected on a fresh visit (26 Oct, Mat). Only a shared plan link opens with answers filled in */
    if (!s) return;
    ['mode', 'age', 'size', 'style', 'first'].forEach(function (n) { if (!s[n]) return; var el = form.querySelector('input[name="' + n + '"][value="' + s[n] + '"]'); if (el) el.checked = true; });
    if (s.place) form.place.value = s.place;
    if (s.date) form.date.value = s.date;
  }

  function showFields(mode) {
    $$('.cg-fs[data-show]', form).forEach(function (f) { f.hidden = !mode || f.getAttribute('data-show').split(' ').indexOf(mode) < 0; });
    $$('legend [data-for]', form).forEach(function (l) { l.classList.toggle('on', l.getAttribute('data-for') === mode); });
    var di = form.date, t = today();
    if (mode === 'soon') { di.min = iso(t); di.removeAttribute('max'); }
    else if (mode === 'healing') { di.max = iso(t); di.min = iso(add(t, -42)); }
  }
  function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }

  function extras(s) {
    var x = 0, tips = [];
    [['places', s.place], ['styles', s.style], ['sizes', s.size], ['ages', s.age]].forEach(function (p) {
      var row = DATA[p[0]] && DATA[p[0]][p[1]];
      if (!row) return;
      x = Math.max(x, row[0]);
      tips = tips.concat(row[1]);
    });
    if (s.mode === 'soon' && s.first && DATA.first) tips = tips.concat(DATA.first[s.first] || []);
    return { lock: 14 + x, tips: tips };
  }

  function item(d, t, desc, stage, now) { return { d: d, t: t, desc: desc, stage: stage, now: now }; }

  function build(s) {
    var t = today(), e = extras(s), day0 = parse(s.date), L = e.lock, items = [], sum = '', meta = [], rec = [];
    if (s.mode === 'soon' || s.mode === 'healing') {
      if (!day0) return { need: s.mode === 'soon' ? 'Choose your appointment date to see your dates.' : 'Choose the date of your tattoo to see where you are up to.' };
      var n = diff(day0, t);
      if (s.mode === 'soon' && n < 0) return { need: 'That date has passed. Choose an upcoming appointment, or switch to Just got tattooed.' };
      if (s.mode === 'healing' && n > 0) return { need: 'That date is in the future. Choose the day you were tattooed.' };
      if (s.mode === 'soon') {
        sum = n === 0 ? 'Your appointment is today.' : n === 1 ? 'Your appointment is tomorrow.' : 'Your appointment is in ' + n + ' days, on ' + long(day0) + '.';
        if (n >= 21) items.push(item(add(day0, -21), 'Start PRIME', 'A thin layer on the area, twice a day. Keep the skin out of the sun.', 'Prepare'));
        else if (n >= 2) items.push(item(t, 'Start PRIME today', 'You have ' + n + ' days. Twice a day on the area still makes a difference.', 'Prepare'));
        if (n >= 7) items.push(item(add(day0, -7), 'Pause actives on the area', 'No retinoids, acids, scrubs, peels, waxing or laser there.', 'Prepare'));
        if (n >= 2) items.push(item(add(day0, -2), 'No sunburn, no tanning', 'And go easy on alcohol.', 'Prepare'));
        if (n >= 1) items.push(item(add(day0, -1), 'The day before', 'No alcohol. Sleep well. Your last PRIME at least 12 hours before.', 'Prepare'));
        items.push(item(day0, 'Appointment day', 'Eat a proper meal, drink water, wear loose clothes and bring a snack.', 'Day 0'));
      } else {
        var dn = -n;
        sum = dn === 0 ? 'You were tattooed today. Welcome to Recover.' : 'You are on day ' + dn + ' of healing.';
      }
      items.push(item(add(day0, 1), 'Covering off, LOCK on', 'As your artist advises. Wash gently, pat dry, then a thin layer of LOCK 3 to 5 times a day.', 'Recover'));
      items.push(item(add(day0, 4), 'Swelling settles', 'Keep washing and moisturising lightly. Loose clothes, no soaking, no sun.', 'Recover'));
      items.push(item(add(day0, 8), 'Flaking and itch', 'Normal. Never pick or scratch. Tap the itch. Ease back into light training.', 'Recover'));
      items.push(item(add(day0, L), 'Check in', 'Still flaking, shiny or tender? Keep going with LOCK until it is fully closed.', 'Recover'));
      items.push(item(add(day0, L + 1), 'Start SHIELD', 'Once the surface is fully closed. Every morning on exposed tattoos, reapplied every 2 hours outdoors.', 'Protect'));
      items.push(item(add(day0, 28), 'Touch-up window opens', 'From 4 to 8 weeks, if your artist offers one. Swimming is fine once fully healed.', 'Protect'));
      meta.push(ic('clock') + 'LOCK for ' + L + ' days');
      meta.push(ic('shield') + 'SHIELD from ' + dd(add(day0, L + 1)) + ' ' + mm(add(day0, L + 1)));
      var nowIdx = -1;
      items.forEach(function (it, i) { if (diff(it.d, t) <= 0) nowIdx = i; });
      items.forEach(function (it, i) { it.past = i < nowIdx; it.now = i === nowIdx && s.mode === 'healing'; });
      if (s.mode === 'soon') {
        if (n < 2) rec = ['lock', 'shield'];
        else rec = s.first === 'no' ? ['system-lux'] : ['system-plus'];
      } else rec = diff(t, day0) <= L ? ['lock', 'shield'] : ['shield'];
    } else if (s.mode === 'healed') {
      sum = 'Your tattoo is healed. Now it is all about protection.';
      items.push(item(null, 'Every morning', 'SHIELD on every exposed tattoo, the last step of your routine, 20 minutes before you go out.', 'Protect'));
      items.push(item(null, 'Every 2 hours outdoors', 'Reapply, and again after swimming, sweating or towelling.', 'Protect'));
      items.push(item(null, 'Long days outside', 'Add SPF50+, clothing, a hat and shade.', 'Protect'));
      items.push(item(null, 'At about 3 years', 'Add LUME to refresh the look of the skin over your ink.', 'Restore'));
      rec = ['shield'];
    } else if (s.mode === 'mature') {
      sum = 'Your tattoo is ready for Restore.';
      items.push(item(null, 'Days 1 to 10', 'LUME twice a day on clean, dry skin. Take a photo on day 1 in good light.', 'Restore'));
      items.push(item(null, 'Day 10', 'Take another photo in the same light and compare.', 'Restore'));
      items.push(item(null, 'Then', 'LUME 2 to 3 times a week to keep it up.', 'Restore'));
      items.push(item(null, 'Every day', 'SHIELD every morning once LUME has absorbed.', 'Protect'));
      rec = ['lume', 'shield'];
    } else return null;
    return { sum: sum, meta: meta, items: items, tips: e.tips, rec: rec, day0: day0, L: L };
  }

  var REC = {
    'system-plus': 'PRIME, LOCK and SHIELD, for the weeks before, the weeks after and every day once healed.',
    'system-lux': 'All 4 stages. PRIME, LOCK and SHIELD for the new piece, and LUME for the tattoos you already wear.',
    lock: 'Ready for the moment your covering comes off. A light, petrolatum-free texture for fresh skin.',
    shield: 'Daily protection for healed tattoos, every morning on exposed skin.',
    lume: 'Refreshes the look of older ink. Best on tattoos 3 years or older.',
    prime: 'Calm, hydrated skin for the 21 days before your appointment.'
  };

  var last = null;
  function render() {
    var s = state();
    showFields(s.mode);
    save(s);
    var p = build(s);
    var err = $('[data-err]', form);
    if (!p) return;
    if (p.need) {
      out.innerHTML = '<div class="cg-out-empty">' + ic('cal').replace('cg-i', 'cg-i cg-out-ei') + '<p class="cg-out-et">Almost there</p><p>' + esc(p.need) + '</p></div>';
      last = null;
      return;
    }
    last = p; last.s = s;
    var h = '<div class="cg-out-hd"><p class="lbl">Your plan</p><p class="cg-out-sum">' + esc(p.sum) + '</p>' +
      (p.meta.length ? '<div class="cg-out-meta">' + p.meta.map(function (m) { return '<span class="cg-pill">' + m + '</span>'; }).join('') + '</div>' : '') + '</div>';
    h += '<ol class="cg-out-tl">' + p.items.map(function (it) {
      var cls = it.past ? 'is-past' : it.now ? 'is-now' : '';
      var tm = it.d ? '<time datetime="' + iso(it.d) + '"><b>' + dd(it.d) + '</b>' + mm(it.d) + '</time>' : '<time>' + ic('tick') + '</time>';
      return '<li class="' + cls + '">' + tm + '<div><p class="t">' + esc(it.t) + '<i>' + (it.now ? 'Today' : esc(it.stage)) + '</i></p><p class="d">' + esc(it.desc) + '</p></div></li>';
    }).join('') + '</ol>';
    if (p.tips.length) h += '<div class="cg-out-blk"><p class="lbl">For you</p><ul class="cg-out-tips">' + p.tips.slice(0, 7).map(function (t) { return '<li>' + ic('info') + '<span>' + esc(t) + '</span></li>'; }).join('') + '</ul></div>';
    var recs = p.rec.filter(function (k) { return PROD[k] && PROD[k].u; });
    if (recs.length) h += '<div class="cg-out-blk"><p class="lbl">What you need</p>' + recs.map(function (k) {
      var r = PROD[k];
      return '<a class="cg-out-rec" href="' + esc(r.u) + '"><img src="' + esc(r.i || '') + '" alt="" loading="lazy"><div><b>' + esc(r.t) + '</b><span>' + esc(REC[k] || '') + '</span><em>Shop ' + esc(r.t) + (r.p ? ', ' + esc(r.p) : '') + '</em></div></a>';
    }).join('') + '</div>';
    var take = [];
    if (p.day0) take.push(['ics', 'cal', 'Add to calendar', 'Every date, with a reminder']);
    take.push(['pdf', 'doc', 'Save as PDF', 'Print it, or keep it on your phone']);
    take.push(['mail', 'mail', 'Email it to me', 'Your plan, in your inbox']);
    take.push(navigator.share ? ['share', 'share', 'Share', 'Send it by message'] : ['copy', 'link', 'Copy link', 'Opens your plan anywhere']);
    h += '<div class="cg-take"><p class="lbl">Take it with you</p><div class="cg-take-g">' + take.map(function (t) {
      return '<button type="button" class="cg-take-b" data-take="' + t[0] + '">' + ic(t[1]) + '<b>' + t[2] + '</b><small>' + t[3] + '</small></button>';
    }).join('') + '</div>' + mailForm() + '<p class="cg-take-n" data-take-n role="status" hidden></p></div>';
    h += '<div class="cg-out-act"><a class="btn btn--ghost" href="#' + ({ soon: 'prepare', healing: 'recover', healed: 'protect', mature: 'restore' })[s.mode] + '">Read your stage</a></div>';
    h += '<p class="cg-out-x">General skincare guidance, not medical advice. Always follow your artist.</p>';
    out.innerHTML = h;
    if (err) err.hidden = true;
  }

  /* calendar file with every dated step, so the plan lives where they already look */
  function ics() {
    if (!last || !last.day0) return;
    var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//SKINGRAPHICA//Care Plan//EN', 'CALSCALE:GREGORIAN'];
    var stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d+/, '');
    last.items.forEach(function (it, i) {
      if (!it.d || it.past) return;
      var d = iso(it.d).replace(/-/g, ''), e = iso(add(it.d, 1)).replace(/-/g, '');
      lines.push('BEGIN:VEVENT', 'UID:sg-care-' + d + '-' + i + '@skingraphica.com', 'DTSTAMP:' + stamp, 'DTSTART;VALUE=DATE:' + d, 'DTEND;VALUE=DATE:' + e,
        'SUMMARY:' + ('SKINGRAPHICA ' + it.t).replace(/[,;]/g, ' '), 'DESCRIPTION:' + it.desc.replace(/[,;]/g, ' ') + ' ' + planUrl(last.s).replace(/[,;]/g, ''),
        'BEGIN:VALARM', 'ACTION:DISPLAY', 'DESCRIPTION:' + ('SKINGRAPHICA ' + it.t).replace(/[,;]/g, ' '), 'TRIGGER:PT9H', 'END:VALARM', 'END:VEVENT');
    });
    lines.push('END:VCALENDAR');
    var blob = new Blob([lines.join('\r\n')], { type: 'text/calendar' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'skingraphica-care-plan.ics';
    document.body.appendChild(a); a.click();
    setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
  }

  /* email my plan. The plan goes to Klaviyo as a Requested Care Plan event, which sends the email and keeps the analytics */
  var KL = { id: 'UVFXN8', list: 'RfnsmX', metric: 'Requested Care Plan', rev: '2024-10-15' };
  var mailOpen = false, MKEY = 'sg-care-email';
  function savedEmail() { try { return localStorage.getItem(MKEY) || ''; } catch (e) { return ''; } }
  function mailForm() {
    return '<form class="cg-mail" data-cg-mail novalidate' + (mailOpen ? '' : ' hidden') + '>' +
      '<label class="cg-mail-l" for="cg-mail-e">Where should we send it?</label>' +
      '<div class="cg-mail-r"><input id="cg-mail-e" type="email" name="email" autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false" placeholder="Your email" required value="' + esc(savedEmail()) + '"><button class="btn" type="submit">Send my plan</button></div>' +
      '<label class="cg-mail-ok"><input type="checkbox" name="news"><span>Also send me care tips, new releases and members’ news from SKINGRAPHICA®. Unsubscribe any time.</span></label>' +
      '<p class="cg-mail-x">We use your email to send your plan, and only send more if you tick the box. <a href="/policies/privacy-policy">Privacy policy</a></p>' +
      '<p class="cg-mail-x">Prefer your own mail app? <a href="#" data-take="mailapp">Open it there</a></p>' +
      '</form>';
  }
  function klPost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KL.id, {
      method: 'POST', headers: { 'content-type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: KL.rev }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); return r; });
  }
  function eventProps(p, optin) {
    var s = p.s, a = {}, day0 = p.day0, t = today();
    answers(s).forEach(function (x) { a[x[0]] = x[1]; });
    var steps = p.items.filter(function (it) { return !it.past; }).map(function (it) {
      return { Date: it.d ? fmt(it.d, { weekday: 'short', day: 'numeric', month: 'short' }) : '', Title: it.t, Detail: it.desc, Stage: it.now ? 'Today' : it.stage };
    });
    var guides = (STAGES[s.mode] || []).map(stageInfo).filter(Boolean).map(function (st) {
      return { Name: 'Stage ' + st.n + ' · ' + st.name, Heading: st.h, Do: st.yes, Avoid: st.no };
    });
    var signs = (s.mode === 'soon' || s.mode === 'healing') ? $$('.cg-sg li').map(function (li) {
      var d = li.querySelector('.cg-sg-d span'), c = d ? d.cloneNode(true) : null; if (c && c.querySelector('em')) c.querySelector('em').remove();
      return { Sign: txt(li.querySelector('.cg-sg-n')), When: txt(c) };
    }) : [];
    var prods = p.rec.filter(function (k) { return PROD[k] && PROD[k].u; }).map(function (k) {
      var r = PROD[k], im = r.i || ''; if (/^\/\//.test(im)) im = 'https:' + im;
      return { Name: r.t, Price: r.p || '', URL: abs(r.u), Image: im, Line: REC[k] || '', Key: k };
    });
    return {
      Source: 'The Tattoo Care Guide', StageKey: s.mode, Stage: a['Where you are at'] || '', Summary: p.sum,
      AppointmentDate: s.mode === 'soon' && day0 ? iso(day0) : '', TattooDate: s.mode === 'healing' && day0 ? iso(day0) : '',
      DaysToAppointment: s.mode === 'soon' && day0 ? diff(day0, t) : null, HealingDay: s.mode === 'healing' && day0 ? diff(t, day0) : null,
      AgeBand: a.Age || '', Placement: a.Placement || '', Size: a.Size || '', Style: a.Style || '', FirstTattoo: a['First tattoo'] || '',
      LockDays: day0 ? p.L : null, MarketingOptIn: !!optin, RecommendedProducts: prods.map(function (x) { return x.Name; }),
      Tips: p.tips.slice(0, 7), Steps: steps, StageGuides: guides, DoctorSigns: signs, Products: prods,
      PlanURL: planUrl(s), GuideURL: location.origin + location.pathname
    };
  }
  function profileProps(p, ev) {
    var o = { 'Care Stage': ev.Stage, 'Care Plan URL': ev.PlanURL };
    if (ev.Placement) o['Tattoo Placement'] = ev.Placement;
    if (ev.Style) o['Tattoo Style'] = ev.Style;
    if (ev.Size) o['Tattoo Size'] = ev.Size;
    if (ev.AgeBand) o['Age Band'] = ev.AgeBand;
    if (ev.FirstTattoo) o['First Tattoo'] = ev.FirstTattoo;
    if (ev.AppointmentDate) o['Next Appointment'] = ev.AppointmentDate;
    if (ev.TattooDate) o['Last Tattoo Date'] = ev.TattooDate;
    return o;
  }
  function sendPlan(form) {
    var inp = form.email, btn = form.querySelector('button[type=submit]'), email = (inp.value || '').trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { inp.focus(); note('Check your email address and try again.'); return; }
    var optin = form.news && form.news.checked, ev = eventProps(last, optin);
    btn.disabled = true; btn.textContent = 'Sending';
    var jobs = [klPost('events', { data: { type: 'event', attributes: {
      properties: ev, unique_id: 'care-' + Date.now(),
      metric: { data: { type: 'metric', attributes: { name: KL.metric } } },
      profile: { data: { type: 'profile', attributes: { email: email, properties: profileProps(last, ev) } } }
    } } })];
    if (optin) jobs.push(klPost('subscriptions', { data: { type: 'subscription', attributes: {
      custom_source: 'Care plan', profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
    }, relationships: { list: { data: { type: 'list', id: KL.list } } } } }));
    Promise.all(jobs).then(function () {
      try { localStorage.setItem(MKEY, email); } catch (e) {}
      mailOpen = false;
      form.outerHTML = '<div class="cg-mail-done" role="status">' + ic('tick') + '<p><b>Your plan is on its way.</b>Sent to ' + esc(email) + '. It usually lands within a few minutes. Check your promotions folder if you cannot see it.</p></div>';
    }, function () {
      btn.disabled = false; btn.textContent = 'Send my plan';
      note('We could not send it just now. Try again, or open it in your own mail app.');
    });
  }

  /* the answers, in words */
  function answers(s) {
    var a = [];
    function chip(n) { var el = form.querySelector('input[name="' + n + '"]:checked + span'); return el ? el.textContent.trim() : ''; }
    var m = chip('mode'); if (m) a.push(['Where you are at', m]);
    if (s.date && (s.mode === 'soon' || s.mode === 'healing')) { var d = parse(s.date); if (d) a.push([s.mode === 'soon' ? 'Appointment' : 'Tattooed', long(d)]); }
    var g = chip('age'); if (g) a.push(['Age', g]);
    if (form.place.value) a.push(['Placement', form.place.options[form.place.selectedIndex].text]);
    if (s.mode === 'soon' || s.mode === 'healing') { var z = chip('size'); if (z) a.push(['Size', z]); }
    var y = chip('style'); if (y) a.push(['Style', y]);
    if (s.mode === 'soon') { var f = chip('first'); if (f) a.push(['First tattoo', f]); }
    return a;
  }
  function abs(u) { return /^https?:/.test(u) ? u : location.origin + u; }
  function recs(p) { return p.rec.filter(function (k) { return PROD[k] && PROD[k].u; }).map(function (k) { return PROD[k]; }); }
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function kids(sel, c) { return $$(sel, c).map(txt).filter(Boolean); }
  var STAGES = { soon: ['prepare', 'recover'], healing: ['recover', 'protect'], healed: ['protect'], mature: ['restore', 'protect'] };
  function stageInfo(id) {
    var sec = document.getElementById(id); if (!sec) return null;
    var nl = bar && bar.querySelector('a[data-for="' + id + '"]'), n = nl ? txt(nl.querySelector('span')) : '';
    var name = nl ? txt(nl).replace(/^\d+\s*/, '') : id;
    var da = sec.querySelector('.cg-da:not(.cg-da--can)');
    var steps = $$('.cg-steps li', sec).map(function (li) { return [txt(li.querySelector('b')), txt(li.querySelector('p'))]; });
    return { n: n, name: name, h: txt(sec.querySelector('.cg-h2')), steps: steps, steps3: !!sec.querySelector('.cg-steps--3'),
      yes: da ? kids('.cg-do li span', da) : [], no: da ? kids('.cg-dont li span', da) : [] };
  }

  /* plain words for email and messages. No colons, no fuss */
  function plain(p) {
    var L = ['My SKINGRAPHICA® care plan', '', p.sum, answers(p.s).map(function (a) { return a[1]; }).join(' · '), ''];
    var dated = p.items.filter(function (it) { return !it.past; });
    L.push(p.day0 ? 'YOUR DATES' : 'YOUR ROUTINE');
    dated.forEach(function (it) { L.push((it.d ? fmt(it.d, { weekday: 'short', day: 'numeric', month: 'short' }) + ' · ' : '') + it.t, it.desc, ''); });
    if (p.tips.length) { L.push('FOR YOU'); p.tips.slice(0, 5).forEach(function (t) { L.push('- ' + t); }); L.push(''); }
    var r = recs(p);
    if (r.length) { L.push('WHAT YOU NEED'); r.forEach(function (x) { L.push(x.t + (x.p ? ' · ' + x.p : ''), abs(x.u)); }); L.push(''); }
    L.push('Open your plan any time', planUrl(p.s), '', 'The full Tattoo Care Guide', location.origin + location.pathname, '',
      'Questions about your tattoo or your skin? concierge@skingraphica.com', '', 'General skincare guidance, not medical advice. Always follow your artist.');
    return L.join('\n');
  }

  /* the printed plan. One clean sheet, built on demand, printed or saved as a PDF */
  var TICK = '<svg viewBox="0 0 24 24" class="cgp-k cgp-k--y" aria-hidden="true"><path d="M5 12.6l4.3 4.3L19 7.2"/></svg>';
  var CROSS = '<svg viewBox="0 0 24 24" class="cgp-k cgp-k--n" aria-hidden="true"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/></svg>';
  var DOC = '<svg viewBox="0 0 24 24" class="cgp-k cgp-k--d" aria-hidden="true"><path d="M12 4.5v15M4.5 12h15"/></svg>';
  function sheet(p) {
    var s = p.s, h = '';
    var lg = document.querySelector('img.logo, .logo img, .logo svg');
    var brand = lg ? lg.outerHTML : 'SKINGRAPHICA<sup>®</sup>';
    h += '<header class="cgp-hd"><div class="cgp-brand">' + brand + '</div><p class="cgp-hm">The Tattoo Care Guide<br>Made ' + esc(fmt(new Date(), { day: 'numeric', month: 'long', year: 'numeric' })) + '</p></header>';
    h += '<h1>Your tattoo care plan</h1><p class="cgp-sum">' + esc(p.sum) + '</p>';
    h += '<dl class="cgp-ans">' + answers(s).map(function (a) { return '<div><dt>' + esc(a[0]) + '</dt><dd>' + esc(a[1]) + '</dd></div>'; }).join('') + '</dl>';
    if (p.meta.length) h += '<p class="cgp-meta">' + p.meta.map(function (m) { return '<span>' + m.replace(/<svg[\s\S]*?<\/svg>/, '') + '</span>'; }).join('') + '</p>';
    h += '<section class="cgp-s"><h2>' + (p.day0 ? 'Your dates' : 'Your routine') + '</h2><table class="cgp-tl"><tbody>' + p.items.map(function (it) {
      return '<tr class="' + (it.past ? 'is-past' : '') + '"><td class="cgp-bx"><span>' + (it.past ? TICK : '') + '</span></td><td class="cgp-dt">' +
        (it.d ? '<b>' + esc(dd(it.d)) + '</b>' + esc(fmt(it.d, { month: 'short' })) + '<i>' + esc(fmt(it.d, { weekday: 'short' })) + '</i>' : '') +
        '</td><td><b class="cgp-t">' + esc(it.t) + '</b><span class="cgp-d">' + esc(it.desc) + '</span></td><td class="cgp-stg"><span>' + esc(it.stage) + '</span></td></tr>';
    }).join('') + '</tbody></table></section>';
    if (p.tips.length) h += '<section class="cgp-s"><h2>For you</h2><ul class="cgp-tips">' + p.tips.slice(0, 7).map(function (t) { return '<li>' + DOC + '<span>' + esc(t) + '</span></li>'; }).join('') + '</ul></section>';
    (STAGES[s.mode] || []).map(stageInfo).filter(Boolean).forEach(function (st) {
      h += '<section class="cgp-s cgp-st"><h2>Stage ' + esc(st.n) + ' · ' + esc(st.name) + '</h2><p class="cgp-sth">' + esc(st.h) + '</p>';
      if (st.steps.length) h += '<p class="cgp-l">' + (st.steps3 ? 'Your daily routine' : 'Washing, step by step') + '</p><ol class="cgp-steps">' + st.steps.map(function (x, i) { return '<li><i>' + (i + 1) + '</i><b>' + esc(x[0]) + '</b><span>' + esc(x[1]) + '</span></li>'; }).join('') + '</ol>';
      h += '<div class="cgp-da"><div><p class="cgp-l">' + TICK + 'Do</p><ul>' + st.yes.map(function (t) { return '<li>' + TICK + '<span>' + esc(t) + '</span></li>'; }).join('') + '</ul></div>' +
        '<div><p class="cgp-l">' + CROSS + 'Avoid</p><ul>' + st.no.map(function (t) { return '<li>' + CROSS + '<span>' + esc(t) + '</span></li>'; }).join('') + '</ul></div></div></section>';
    });
    if (s.mode === 'soon' || s.mode === 'healing') {
      var sg = $$('.cg-sg li').map(function (li) { var d = li.querySelector('.cg-sg-d span'); var c = d ? d.cloneNode(true) : null; if (c && c.querySelector('em')) c.querySelector('em').remove(); return [txt(li.querySelector('.cg-sg-n')), txt(c)]; });
      if (sg.length) {
        var em = $('.cg-emg p'), emt = em ? em.cloneNode(true) : null; if (emt && emt.querySelector('b')) emt.querySelector('b').remove();
        h += '<section class="cgp-s"><h2>Speak to a doctor</h2><ul class="cgp-sg">' + sg.map(function (x) { return '<li><b>' + esc(x[0]) + '</b><span>' + esc(x[1]) + '</span></li>'; }).join('') + '</ul>' +
          (emt ? '<p class="cgp-emg"><b>Emergency</b> ' + esc(txt(emt)) + '</p>' : '') + '</section>';
      }
    }
    var r = recs(p);
    if (r.length) h += '<section class="cgp-s"><h2>What you need</h2><ul class="cgp-rec">' + r.map(function (x) { return '<li><b>' + esc(x.t) + '</b><span>' + esc(x.p || '') + '</span><em>' + esc(abs(x.u).replace(/^https?:\/\//, '').replace(/[?#].*$/, '')) + '</em></li>'; }).join('') + '</ul></section>';
    h += '<footer class="cgp-ft"><div><p class="cgp-l">Open your plan any time</p><p class="cgp-u">' + esc(planUrl(s).replace(/^https?:\/\//, '')) + '</p></div><div><p class="cgp-l">Questions about your tattoo or your skin</p><p class="cgp-u">concierge@skingraphica.com</p></div>' +
      '<p class="cgp-x">General skincare information, not medical advice. Always follow your artist, and speak to your doctor if your tattoo looks infected, irritated or is not healing as expected.</p></footer>';
    var el = document.getElementById('cg-print');
    if (!el) { el = document.createElement('div'); el.id = 'cg-print'; document.body.appendChild(el); }
    el.innerHTML = h;
    return el;
  }
  function pdf() {
    if (!last) return;
    sheet(last);
    var html = document.documentElement, t0 = document.title;
    html.classList.add('cg-printing');
    document.title = 'SKINGRAPHICA care plan';
    var done = function () { html.classList.remove('cg-printing'); document.title = t0; window.removeEventListener('afterprint', done); };
    window.addEventListener('afterprint', done);
    window.print();
  }
  function note(msg) { var n = $('[data-take-n]', out); if (!n) return; n.textContent = msg; n.hidden = false; clearTimeout(note.t); note.t = setTimeout(function () { n.hidden = true; }, 5000); }
  function copy(text, ok) {
    var fall = function () { var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;opacity:0;top:0'; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); note(ok); } catch (e) { note('Copy this link ' + text); } ta.remove(); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(function () { note(ok); }, fall); else fall();
  }
  function takeAway(kind) {
    if (!last) return;
    if (kind === 'ics') { ics(); note('Your calendar file is downloading. Open it to add every date.'); }
    else if (kind === 'pdf') pdf();
    else if (kind === 'mail') {
      mailOpen = !mailOpen;
      var f = $('[data-cg-mail]', out);
      if (f) { f.hidden = !mailOpen; if (mailOpen) { var e = f.email; setTimeout(function () { e.focus({ preventScroll: true }); f.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 30); } }
    } else if (kind === 'mailapp') {
      var body = plain(last);
      note('Your email app opens with the plan ready. Add your address and send it to yourself.');
      location.href = 'mailto:?subject=' + encodeURIComponent('My SKINGRAPHICA care plan') + '&body=' + encodeURIComponent(body);
    } else if (kind === 'share') {
      navigator.share({ title: 'My SKINGRAPHICA care plan', text: last.sum + ' Here is my tattoo care plan.', url: planUrl(last.s) }).catch(function () {});
    } else if (kind === 'copy') copy(planUrl(last.s), 'Link copied. Open it on any device to see your plan.');
  }

  form.addEventListener('change', render);
  form.addEventListener('input', function (e) { if (e.target.name === 'date') render(); });
  out.addEventListener('click', function (e) { var b = e.target.closest('[data-take]'); if (b) { e.preventDefault(); takeAway(b.getAttribute('data-take')); } });
  out.addEventListener('submit', function (e) { var f = e.target.closest('[data-cg-mail]'); if (!f) return; e.preventDefault(); sendPlan(f); });
  load();
  render();
  if (linked && location.hash !== '#plan') {
    var goPlan = function () { var pl = document.getElementById('plan'); if (pl) pl.scrollIntoView(); };
    if (document.readyState === 'complete') setTimeout(goPlan, 60); else window.addEventListener('load', function () { setTimeout(goPlan, 60); });
  }

  /* only one myth open at a time keeps the grid calm */
  $$('.cg-my').forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) $$('.cg-my[open]').forEach(function (o) { if (o !== d) o.open = false; }); }); });
})();
